import Period from "./Period";
class ReferenceRate {
    benchmark;
    designatedMaturity;
    constructor(response) {
        this.benchmark = response.benchmark;
        this.designatedMaturity = response.designatedMaturity !== undefined ? new Period(response.designatedMaturity) : undefined;
    }
    printShort() {
        const list = [];
        if (this.designatedMaturity !== undefined) {
            list.push(this.designatedMaturity.print().toLowerCase());
        }
        switch (this.benchmark) {
            case 'BBSW':
                list.push('BBSW');
                break;
            case 'DM':
                list.push('DM');
                break;
            case 'EURIBOR':
                list.push('E');
                break;
            case 'NIBOR':
                list.push('N');
                break;
            case 'SOFR':
                list.push('SOFR');
                break;
            case 'SONIA':
                list.push('SONIA');
                break;
            case 'STIBOR':
                list.push('S');
                break;
            case 'WIBOR':
                list.push('W');
                break;
            case 'TONA':
                list.push('TONA');
                break;
            default:
        }
        //
        return list.join('');
    }
}
export default ReferenceRate;
